import system from './system'
import user from './user'
import common from './common'
import summary from './summary'
import attendanceQuery from './attendanceQuery'
import systemConfig from './systemConfig'
import AccommodationManagement from './AccommodationManagement'
import sanitationManage from './sanitationManage'
import accessManage from './accessManage'



export default {
    system,
    user,
    common,
    summary,
    attendanceQuery,
    systemConfig,
    AccommodationManagement,
    sanitationManage,
    accessManage

}



// WEBPACK FOOTER //
// ./src/api/index.js